import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupCarreras } from '../Carreras/LookupCarreras';
import { SELECT_LABELS, selectPlaceholder, withSelectPlaceholder } from '../../services/selectOptions';

const PRACTICA_OPTIONS = withSelectPlaceholder(
  [
    { value: 'S', label: 'Sí' },
    { value: 'N', label: 'No' },
  ],
  SELECT_LABELS.practica
);

const DICTADO_OPTIONS = withSelectPlaceholder(
  [
    { value: '1', label: 'Primer Cuatrimestre' },
    { value: '2', label: 'Segundo Cuatrimestre' },
    { value: 'A', label: 'Anual' },
  ],
  SELECT_LABELS.cuatrimestre
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddMateria extends Component {
  static displayName = AddMateria.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      code: '',
      name: '',
      anioDictado: '',
      dictado: '',
      practica: '',
      errorMessage: '',
      redirect: false,
      carrera: { codigo: '', nombre: '' },
      showLookupCarreras: false,
      valuePractica: selectPlaceholder(SELECT_LABELS.practica),
      valueDictado: selectPlaceholder(SELECT_LABELS.cuatrimestre),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWMaterias');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleFieldChange = (field) => (e) => {
    this.clearFeedback();
    this.setState({ [field]: e.target.value });
  };

  handlePracticaChange = (option) => {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({ valuePractica: option, practica: value });
  };

  handleDictadoChange = (option) => {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({ valueDictado: option, dictado: value });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupCarreras: false,
      carrera: {
        codigo: carreraProperties[0],
        nombre: carreraProperties[1],
      },
    });
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupCarreras: true });
    }
  };

  handleHideCarreraLookup = () => {
    this.setState({ showLookupCarreras: false });
  };

  isFormValid() {
    return (
      this.state.code.trim().length > 0
      && this.state.name.trim().length > 0
      && this.state.anioDictado.trim().length > 0
      && this.state.dictado.length > 0
      && this.state.practica.length > 0
      && this.state.carrera.nombre.trim().length > 0
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveMateria();
  }

  async saveMateria() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/Materia', {
      method: 'POST',
      body: JSON.stringify({
        MateriaCarreraCodigo: this.state.code,
        MateriaCarreraNombre: this.state.name,
        MateriaCarreraDictado: this.state.dictado,
        MateriaCarreraAnio: this.state.anioDictado,
        MateriaPractica: this.state.practica,
        CarreraCod: this.state.carrera.codigo,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar la materia. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-mxc" />;
    }

    const {
      loading,
      code,
      name,
      anioDictado,
      carrera,
      showLookupCarreras,
      valuePractica,
      valueDictado,
      errorMessage,
    } = this.state;

    const carreraDisplay = carrera.codigo.trim() && carrera.nombre.trim()
      ? carrera.codigo.trim() + ' - ' + carrera.nombre.trim()
      : '';

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-mxc">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nueva Materia</h1>
        <p className="md-form-page__subtitle">
          Complete los datos para registrar una nueva materia en el instituto.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando materia, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="materia-codigo">
                Código Materia
              </label>
              <input
                id="materia-codigo"
                className="md-form-page__input"
                type="text"
                name="code"
                autoComplete="off"
                placeholder="Ingrese código"
                value={code}
                onChange={this.handleFieldChange('code')}
                disabled={loading}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="materia-nombre">
                Nombre Materia
              </label>
              <input
                id="materia-nombre"
                className="md-form-page__input"
                type="text"
                name="name"
                autoComplete="off"
                placeholder="Ingrese nombre"
                value={name}
                onChange={this.handleFieldChange('name')}
                disabled={loading}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="materia-anio">
                Año Dictado
              </label>
              <input
                id="materia-anio"
                className="md-form-page__input"
                type="text"
                name="anioDictado"
                autoComplete="off"
                placeholder="Ingrese año"
                value={anioDictado}
                onChange={this.handleFieldChange('anioDictado')}
                disabled={loading}
                required
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Período de Dictado</span>
              <div className="md-form-page__select-wrap">
                <Select
                  inputId="materia-dictado"
                  classNamePrefix="md-form-page__select"
                  classNames={SELECT_CLASS_NAMES}
                  value={valueDictado}
                  options={DICTADO_OPTIONS}
                  onChange={this.handleDictadoChange}
                  isDisabled={loading}
                />
              </div>
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Carrera</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowCarreraLookup}
                disabled={loading}
              >
                Seleccione la Carrera
              </button>
              {showLookupCarreras ? (
                <LookupCarreras
                  selectItem={this.handleSelectCarreraItem}
                  hideLookup={this.handleHideCarreraLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={carreraDisplay}
                placeholder="Carrera seleccionada"
                readOnly
                disabled
                aria-label="Carrera seleccionada"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia Práctica</span>
              <div className="md-form-page__select-wrap">
                <Select
                  inputId="materia-practica"
                  classNamePrefix="md-form-page__select"
                  classNames={SELECT_CLASS_NAMES}
                  value={valuePractica}
                  options={PRACTICA_OPTIONS}
                  onChange={this.handlePracticaChange}
                  isDisabled={loading}
                />
              </div>
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={loading}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
